import React, { memo, Fragment } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { PopoverText } from '../../common/parts/PopoverText';
import { formatDatetime, formatDatetimeDisplay } from '../../../services/calendar';

import { orderState } from '../../../store/orderState';
import { courceItemState } from '../../../store/courceItemState';
import { isSurveyState } from '../../../store/isSurveyState';

export const FormVenueItemList = memo((props) => {
  const { isConfirm } = props;
  const [orderData, setOrderData] = useRecoilState(orderState);
  const [courceItemData, setCourceItemData] = useRecoilState(courceItemState);
  const isSurvayData = useRecoilValue(isSurveyState);

  const eventClickEvent = (item) => {
    setOrderData({
      ...orderData,
      examdt: formatDatetime(item.start),
      item_id: parseInt(item.id, 10),
    });
  }

  const itemListDisplay = () => {
    return (
      <Fragment>
        {isSurvayData.is_survey ?
          <div className="card bg-light mb-3">
            <div className="card-header fw-bold">選択した会場の開催日時について</div>
            <div className="card-body fw-bold">
              現在、選択された会場で集団健診開催日時を調整しています。<br/>
              この会場での健診ご希望の方は、下記の確認ボタンをクリックし申込を進めてください。
            </div>
          </div>
        :
          <Fragment>
          {courceItemData && 
            <div className="list-group mb-4">
              {courceItemData.map(item => 
                <div key={item.id} className="list-group-item">
                  <input className="form-check-input me-1" type="radio" name="selectCourseVenueItem" id={`item_${item.id}`} onClick={() => eventClickEvent(item)} defaultChecked={item.id == orderData.item_id} />
                      <label className="form-check-label" htmlFor={`item_${item.id}`}>
                        {formatDatetimeDisplay(item.start)}
                  </label>
                </div>
              )}
            </div>
          }
          </Fragment>
        }
      </Fragment>
    )
  }

  const confirmDisplay = () => {
    return (
      <Fragment>
      {isSurvayData.is_survey ?
        <div className="list-group-item mb-3">日時調整中</div>
      :
        <div className="list-group-item mb-3">{formatDatetimeDisplay(orderData.examdt)}</div>
      }
      </Fragment>
    )
  }

  return (
    <>
      <p className="h3">巡回会場の選択 
        <PopoverText textTitle="巡回会場の選択" textBody="都道府県を選択し、会場を選択してください。" />
      </p>
      { isConfirm ?
        <Fragment>{confirmDisplay()}</Fragment>
      :
        <Fragment>{itemListDisplay()}</Fragment>
      }
    </>
  );
});